import React, { useRef, useContext } from "react"
import { navigate } from "gatsby"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import { renderRichTextDinamo } from "../../../../utils/contentful"
import UserContext from "../../../../context/UserContext"

import { RibbonContainer, RibbonLink } from "./ribbon.styled"
import { RIBBON_MAP } from "../../../../constants"

const Ribbon = (props) => {
  let { contentfulHeaderRibbon, PROMO_VARIANT, location } = props
  const ribbonEl = useRef(null)
  const userState = useContext(UserContext)

  if (!contentfulHeaderRibbon) {
    return null
  }

  let ribbonHtml = renderRichTextDinamo(contentfulHeaderRibbon.ribbonText?.raw)
  let ribbonHref = contentfulHeaderRibbon.ribbonLink
  let isPromo = contentfulHeaderRibbon?.ispromo
  if (location?.pathname === ribbonHref) {
    ribbonHref = null
  }
  if (RIBBON_MAP[PROMO_VARIANT]?.copy) {
    ribbonHtml = RIBBON_MAP[PROMO_VARIANT].copy
    if (userState?.customer?.firstname) {
      ribbonHtml = ribbonHtml.replace("{name}", userState?.customer?.firstname)
    }
    ribbonHref = RIBBON_MAP[PROMO_VARIANT].href
    isPromo = false
  }

  const getRibbonAttrs = () => {
    let obj = {
      destination: ribbonHref,
      text: ribbonHtml?.replace(/(<([^>]+)>)/gi, ""),
      type: "ribbon",
      module_location: "ribbon",
    }
    return obj
  }

  const goTo = (e) => {
    segmentEvent("Marketing CTA Clicked", getRibbonAttrs())
    e.preventDefault()
    navigate(ribbonHref)
    return false
  }

  return (
    <RibbonContainer
      className={`ribbon-mobile text-center ribbon-container men ${
        isPromo ? "men-ribbon-promo" : "men-ribbon-regular"
      }`}
    >
      {ribbonHref ? (
        <RibbonLink
          onClick={goTo}
          ref={ribbonEl}
          href={ribbonHref}
          id={`ribbon`}
          className={`body--regular text-men-brand-blue-100 text-center`}
          dangerouslySetInnerHTML={{ __html: ribbonHtml }}
        ></RibbonLink>
      ) : (
        <RibbonLink as="section">
          <TextElement
            element="p"
            text={ribbonHtml}
            className="body--regular text-center text-men-brand-blue-100"
            styles={{
              width: "100%",
              color: theme.wild.color.men.brand.blue[100],
            }}
          />
        </RibbonLink>
      )}
    </RibbonContainer>
  )
}

export default Ribbon
